import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminPanel from "@/components/rexxpons/AdminPanel";
import { AuthProvider } from "@/components/rexxpons/AuthContext";
import AuthCallback from "@/components/rexxpons/AuthCallback";
import Pricing from "@/components/rexxpons/Pricing";
import PaymentSuccess from "@/components/rexxpons/PaymentSuccess";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

function AppRouter() {
  const location = useLocation();
  // Handle the OAuth return (session_id lives in the URL fragment) BEFORE normal routing.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/control" element={<AdminPanel />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<Pricing />} />
      <Route path="*" element={<App />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// Clean up any previously-registered service worker.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister())).catch(() => {});
}
